export default ({...props}) => {
  const {palette, size, themeGrey} = props.theme

  return `
  &> .MuiCheckbox-root{
      margin-bottom:${size(0.75)}px;
      color:${palette.secondary.main};
      &.Mui-checked{
        color:${palette.primary.main};
       }
      &.Mui-disabled{
         color:${themeGrey.input_active};
         &.Mui-checked{
          color:${themeGrey.disabled_grey};
         }
        }
    }
     & .MuiFormControlLabel-label{
         color:${palette.secondary.light};
      } 
`
}
